export const SITE = {
  name: "Tribe Beach Lounge",
  tagline: "Where time flows",
  bookingUrl: "https://tafexperience.simplybook.me/v2/#book",
  whatsapp: "306936121177",
  whatsappDisplay: "+30 693 612 1177",
  phone: "306977637616",
  phoneDisplay: "+30 697 763 7616",
  instagram: "https://www.instagram.com/tribebeachkos/",
  facebook: "https://www.facebook.com/tribebeachkos/",
  email: "info@tafvillaskos.gr",
  location: "Tigaki, Kos, Greece",
  address: "Tribe Beach, Tigaki, Kos, Greece",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Tribe+Beach+Tigaki+Kos",
  googleProfile: "https://share.google/49JCZmJxa4iuBAz47",
  mapEmbed: "https://www.google.com/maps?q=Tribe%20Beach%20Tigaki%20Kos%20Greece&output=embed",
  hours: "Open daily · 9:00 till late",
  menuPdf: "https://customer-assets-7cd3h4nn.emergentagent.net/job_beach-lounge-hub/artifacts/vploo1mh_tribe%20beach%20menu%2024-8-26.pdf",
};

export const ACCESS_POINTS = [
  {
    icon: "Users",
    title: "Open to Everyone",
    desc: "You don't need to be a TAF guest. Tribe Beach is open to all — locals, visitors and families alike.",
  },
  {
    icon: "Armchair",
    title: "Free Sunbeds & Lounges",
    desc: "No entry fee. Sunbeds and lounges are free — only a minimum consumption applies, depending on the size you choose.",
  },
  {
    icon: "Waves",
    title: "Free Water Sports Gear",
    desc: "SUP boards, kayaks and water equipment are completely free to use throughout the day.",
  },
];

export const LOUNGE_TIERS = [
  { size: "Small Lounge", min: "30€", guests: "Up to 4 guests" },
  { size: "Medium Lounge", min: "50€", guests: "Up to 8 guests" },
  { size: "Large Lounge", min: "100€", guests: "Up to 10 guests" },
];

export const HERO_YOUTUBE_ID = "48r239wp7UQ";

export const NAV = [
  { id: "about", label: "About" },
  { id: "lounges", label: "Lounges" },
  { id: "families", label: "Families" },
  { id: "activities", label: "Activities" },
  { id: "menu", label: "Menu" },
  { id: "gallery", label: "Gallery" },
  { id: "contact", label: "Contact" },
];

export const FAMILY_VIDEO = "/family.mp4";

export const FAMILY_POSTER =
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/euxuitcn_e7268e79-206d-452a-852d-061a43a83fa5.JPG";

export const FAMILY_IMAGES = [
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/mp03csnu_IMG_1249.JPG",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/xj9pymhr_IMG_1257.JPG",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/eplv1x22_taf%20villas-63.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/6uyuu47z_taf%20villas-108.jpg",
];

export const PLAYGROUND_IMG =
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/fryk3m4f_DSC01813.jpg";

export const ACTIVITIES = [
  {
    icon: "Waves",
    title: "Stand-Up Paddle",
    desc: "Glide over glassy morning water on our SUP boards — free to use for all our guests, all levels welcome.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/9xqa6y59_DSC01784.jpg",
  },
  {
    icon: "Ship",
    title: "Sea Kayak",
    desc: "Paddle out and explore the coastline and hidden coves — kayaks are free to use throughout the day.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/d69qkxsc_DJI_0415-Edit.jpg",
  },
  {
    icon: "Sailboat",
    title: "Self-Drive Boat Rental",
    desc: "Captain your own day on the Aegean. No licence required — available for half or full day.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/kebwwtke_Sea%20Nomad%20trips%20photos%20%20%201.jpg",
  },
  {
    icon: "Sparkles",
    title: "Beach Spa",
    desc: "Unwind with a massage by the sea — treatments in the shade, set to the sound of the waves.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/q3bvmizd_DSC01914.jpg",
  },
  {
    icon: "Wine",
    title: "Sunset Cocktails",
    desc: "We stay open till late. Signature cocktails, slow music and the best sunsets on the island.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/vssnuomm_DJI_20260614203840_0129_D.jpg",
  },
  {
    icon: "Baby",
    title: "Kids' Playground",
    desc: "A dedicated playground in the sand keeps little ones happy while you settle into the day.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/fryk3m4f_DSC01813.jpg",
  },
];

export const LOUNGES = [
  {
    title: "The Cabanas",
    desc: "Private daybeds beneath timber pergolas, draped for shade and steps from the shoreline — your own quiet corner of Kos.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/fi0f5rd1_DSC01773.jpg",
  },
  {
    title: "Seaside Retreat",
    desc: "An intimate Aegean hideaway where clear turquoise water meets warm sand and slow, golden afternoons.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/65plynsu_DJI_20260612182230_0011_D.jpg",
  },
  {
    title: "The Beachfront",
    desc: "Loungers facing the open sea, for long swims, soft breezes and the first cool light of evening.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/c68sznxl_DSC01790.jpg",
  },
];

export const EXPERIENCES = [
  {
    title: "Drinks & Music",
    desc: "Our beach bar pours cocktails to a slow soundtrack as the sky turns amber and the night settles in.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/vssnuomm_DJI_20260614203840_0129_D.jpg",
  },
  {
    title: "Spa & Wellness",
    desc: "Unwind with a massage by the sea — treatments under the shade, set to the sound of the waves.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/q3bvmizd_DSC01914.jpg",
  },
  {
    title: "Watersports",
    desc: "Kayaks, paddleboards and clear blue water — explore the coastline at your own unhurried pace.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/d69qkxsc_DJI_0415-Edit.jpg",
  },
  {
    title: "Family Days",
    desc: "A dedicated playground in the sand keeps the little ones happy while you settle into the afternoon.",
    img: "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/fryk3m4f_DSC01813.jpg",
  },
];

export const MENU = [
  {
    section: "Signature Cocktails",
    items: [
      { name: "TAF Theory", note: "Aperol, dark rum, strawberry, lime, pink grapefruit soda", price: "14" },
      { name: "TRIBE Vibes", note: "White rum, lime, mango purée, a hint of Tabasco", price: "14" },
      { name: "Midnight Punch", note: "White rum, lime, strawberry, mûre syrup, mint", price: "14" },
      { name: "Yellow Rose", note: "Hendrick's gin & tonic, cucumber, rosemary", price: "14" },
    ],
  },
  {
    section: "Salads & Starters",
    items: [
      { name: "Greek Cheese Platter", note: "Feta, local wine cheese, graviera & gouda, marmelade, dried fruits, olives, pita & breadsticks", price: "15" },
      { name: "Greek Salad", note: "Cucumber, tomatoes, onions, peppers, local feta, olives, EVOO", price: "11" },
      { name: "Caesar Salad", note: "Crisp lettuce, grilled chicken, crispy bacon, croutons, Parmesan", price: "12" },
      { name: "Greek Dips", note: "Tzatziki, hummus & spicy cheese dip, with pita breads", price: "9" },
    ],
  },
  {
    section: "Pinsa",
    items: [
      { name: "Margherita", note: "Tomato sauce, mozzarella, basil", price: "14" },
      { name: "Prosciutto", note: "Basil pesto, prosciutto, mozzarella, Parmesan flakes, rucola", price: "16" },
      { name: "Tartufata", note: "Mozzarella, truffle oil, mushrooms", price: "16" },
      { name: "BBQ Chicken", note: "BBQ sauce, chicken, mozzarella, sweetcorn", price: "16" },
    ],
  },
  {
    section: "Main Dishes",
    items: [
      { name: "Cheeseburger", note: "Black Angus beef, melted cheddar, pickles — brioche bun with fries", price: "16" },
      { name: "Greek Style Burger", note: "Beef, feta mayo, olives, spinach — with fries", price: "15" },
      { name: "Gyros Platter", note: "Pork or chicken, tzatziki, pita, fries", price: "15" },
      { name: "Pasta Bolognese", note: "Slow-cooked beef mince, cinnamon & bay leaf, Parmesan flakes", price: "14" },
    ],
  },
  {
    section: "Desserts",
    items: [
      { name: "Häagen-Dazs Ice Cream", note: "A variety of flavours", price: "6" },
      { name: "Greek Yoghurt", note: "Kalymnos honey & walnuts", price: "8" },
      { name: "Pancakes", note: "Chocolate-hazelnut, maple, or honey & nuts", price: "8" },
      { name: "Chocolate Soufflé", note: "With vanilla ice cream", price: "8" },
    ],
  },
];

export const MENU_IMAGES = [
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/fynln8ls_DSC01634.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/lb1srhf2_DSC01604.jpg",
];

export const INSTAGRAM = [
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/fynln8ls_DSC01634.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/fi0f5rd1_DSC01773.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/vssnuomm_DJI_20260614203840_0129_D.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/5adx0cw6_DSC01533.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/rlgb74sg_DSC02000.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/65plynsu_DJI_20260612182230_0011_D.jpg",
];

export const GALLERY = [
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/euxuitcn_e7268e79-206d-452a-852d-061a43a83fa5.JPG",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/20kdcjme_DSC01743.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/ekk3tn8f_5308ebc3-92e5-48a4-8983-f82443927e8b.JPG",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/ovt3aibx_DSC01469.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/8em4tri8_0fc092be-c3e6-4321-bc14-faa61d507940.JPG",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/vssnuomm_DJI_20260614203840_0129_D.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/3b2wt3zh_DSC02176.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/inxoeawt_DSC02071.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/wshcxo29_DSC02776.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/fi0f5rd1_DSC01773.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/riqf9gcv_DSC01409.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/4sjb96e3_DJI_20260614204019_0137_D.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/c68sznxl_DSC01790.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/wevy50cr_b5fa1a32-8781-4f78-800b-bd45d870e284.JPG",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/2i8eplvu_DJI_20260612182139_0007_D.jpg",
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/g2p6rk6k_DSC01983.jpg",
];

export const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/71t485w1_DJI_0387.jpg";

export const HERO_POSTER =
  "https://customer-assets.emergentagent.com/job_beach-lounge-hub/artifacts/65plynsu_DJI_20260612182230_0011_D.jpg";
